// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__19ycj","calendarButtons":"ClockData_calendarButtons__kPO63"};